// extracted by mini-css-extract-plugin
export var sectionWrapper = "Features-module--section-wrapper--3D5jS";
export var sectionHeader = "Features-module--section-header--1A2oI";